module.exports = __webpack_public_path__ + "eddd0da56c099209f904c0b9668714a0.png";